import { toast } from 'react-toastify'

export const onErrorToast = (err: string) => {
  toast.error(err)
}

export const onSucessToast = (err: string) => {
  toast.success(err)
}